module.exports = __webpack_public_path__ + "img/blouse_1.e4dbb041.png";